import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
import util from '@/libs/util';
import { mapActions } from 'vuex';
export default {
  name: 'app',
  watch: {
    '$i18n.locale': 'i18nHandle'
  },
  created: function created() {
    // console.log('用户信息', JSON.parse(util.cookies.get('userInfo')))
    this.i18nHandle(this.$i18n.locale); // let that = this
    // window.onbeforeunload = function() {
    //   that.logout()
    // }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), {}, {
    i18nHandle: function i18nHandle(val, oldVal) {
      util.cookies.set('lang', val);
      document.querySelector('html').setAttribute('lang', val);
    }
  })
};